import { Heading, P, Footnote, Quote } from "./RichTextComponents";

export const RichTextRenderer = ({ children, node }) => {
  const { style = "normal" } = node;

  switch (style) {
    case "heading":
      return <Heading>{children}</Heading>;
    case "normal":
      return <P>{children}</P>;
    case "paragraph":
      return <P>{children}</P>;
    case "footnote":
      return <Footnote>{children}</Footnote>;
    case "quote":
      return <Quote>{children}</Quote>;
    default:
      return <P>{children}</P>;
  }
};
